import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addTerpene, assignTerpene, getProductTerpenes, getTerpenes, resetAssignTerpeneSuccess, resetAddTerpene, deleteTerpene, resetGetTerpenes, saveTerpene } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';
import '../Styles/MoodTerpene.css';

class ProductTerpene extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        this.props.productId ? this.props.getProductTerpenes(this.props.productId) : alert("Unable to retrieve Terpenes");
        this.props.getTerpenes();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.terpenesSuccess != null && newProps.terpenesSuccess != undefined && newProps.terpenesSuccess != this.props.terpenesSuccess && newProps.terpenesSuccess) {
            this.props.productId ? this.props.getProductTerpenes(this.props.productId) : alert("Unable to retrieve Terpenes");
            this.props.resetAssignTerpeneSuccess();
        }
        if (newProps.addTerpeneSuccess != null && newProps.addTerpeneSuccess != undefined && newProps.addTerpeneSuccess != this.props.addTerpeneSuccess && newProps.addTerpeneSuccess) {
            this.props.getTerpenes();
            this.props.resetAddTerpene();
        }
        if (newProps.productTerpenes != null && newProps.productTerpenes != undefined && newProps.productTerpenes != this.props.productTerpenes && newProps.productTerpenes.length > 0) {
            (newProps.productTerpenes).map((item) => {
                if(this.props.form[`ProductTerpene_${item.id}_Min`] == undefined || this.props.form[`ProductTerpene_${item.id}_Min`] == null) {
                    this.props.formInput((item.min * 100).toFixed(2), `ProductTerpene_${item.id}_Min`);
                    if(item.min==0) this.props.formInput("0", `ProductTerpene_${item.id}_Min`);
                }
                if(this.props.form[`ProductTerpene_${item.id}_Max`] == undefined || this.props.form[`ProductTerpene_${item.id}_Max`] == null) {
                    this.props.formInput((item.max * 100).toFixed(2), `ProductTerpene_${item.id}_Max`);
                    if(item.max==0) this.props.formInput("0", `ProductTerpene_${item.id}_Max`);
                }
            });
        }
    }

    componentWillUnmount() {
        let p = this.props;
        p.productTerpenes.map((item) => {
            this.props.clearFormInput(`ProductTerpene_${item.id}_Min`);
            this.props.clearFormInput(`ProductTerpene_${item.id}_Max`);
        });
    }

    addTerpene = () => {
        let terpeneName = this.props.addTerpeneName;
        let validTerpene = new RegExp('^[A-Za-z]+$');
        if (terpeneName && !validTerpene.test(terpeneName)) {
            alert("Terpene Name cannot contain numbers or symbols");
            return;
        }
        this.props.addTerpene(terpeneName, this.props.branchId);
    }

    addProductTerpene = (terpeneId) => {
        if (!terpeneId === parseInt(terpeneId) || !(this.props.productId)) {
            alert("Unable to assign terpene to product");
            return;
        }
        this.props.assignTerpene(this.props.productId, terpeneId);
    }

    deleteProductTerpene = (terpeneId) => {
        if (!terpeneId === parseInt(terpeneId) || !(this.props.productId)) {
            alert("Unable to un-assign Terpene");
            return;
        }
        this.props.clearFormInput(`ProductTerpene_${terpeneId}_Min`);
        this.props.clearFormInput(`ProductTerpene_${terpeneId}_Max`);
        this.props.deleteTerpene(this.props.productId, terpeneId);
    }

    saveTerpenes = () => {
        let p = this.props;
        p.productTerpenes.map((item) => {
            if(p.form[`ProductTerpene_${item.id}_Min`] < 0 || p.form[`ProductTerpene_${item.id}_Min`] > 100 || p.form[`ProductTerpene_${item.id}_Min`] == undefined || p.form[`ProductTerpene_${item.id}_Min`] == null ||
            p.form[`ProductTerpene_${item.id}_Max`] < 0 || p.form[`ProductTerpene_${item.id}_Max`] > 100 || p.form[`ProductTerpene_${item.id}_Max`] == undefined || p.form[`ProductTerpene_${item.id}_Max`] == null)
            {
                alert("Please assign all Terpene Min/Max, cannot be greater then 100");
                return;
            }
            let min = parseFloat(p.form[`ProductTerpene_${item.id}_Min`]) / 100.0;
            let max = parseFloat(p.form[`ProductTerpene_${item.id}_Max`]) / 100.0;
            if (min != item.min || max != item.max) {
                this.props.saveTerpene(item.id, item.productId, min, max);
            }
        });
    }

    render() {
        const p = this.props;
        let terpenes = p.terpenes;

        return (
            <React.Fragment>
                <div className="row" >
                    {/* LEFT PANEL */}
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pt-0">
                        <TextInput
                            name={`ProductTerpeneAddTerpeneName`}
                            fullWidth={true}
                            label={"Terpene Name"}
                            floatingLabelText={"Terpene Name"}
                            hintText={"Terpene Name"}
                            className="pb-0 mb-0"
                            required />
                        <Button
                            type="AddButton"
                            label="SAVE NEW TERPENE"
                            primary={true}
                            onTouchTap={() => this.addTerpene()} />
                        {
                            !terpenes || terpenes.length == 0 ? <h4>No Terpenes created</h4> :
                                terpenes.map((item) => {
                                    return (
                                        <h6 className="moodListItem"><span>{item.name}</span> <Button style={{ minWidth: `25px`, height: `25px`, marginRight: `5px` }} type="IconAdd" onTouchTap={() => this.addProductTerpene(item.id)} /></h6>)
                                }
                                )
                        }
                    </div>
                    {/* RIGHT PANEL */}
                    <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <h5>{p.propProductName ?  p.propProductName : p.productName}</h5>
                        <h6 className="pb-1">{p.propProductSKU ?  p.propProductSKU : p.productSKU}</h6>
                        <h6 className="pb-1"><u>Assigned Terpenes</u></h6>
                        {
                            !p.productTerpenes || p.productTerpenes.length == 0 ? <h4>No Terpenes assigned</h4> :
                                p.productTerpenes.map((item) => {
                                    return (
                                        <div className='row'>
                                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-3 p-0 terpene-name">{item.name}</div>
                                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 p-0 d-flex align-items-center">
                                                <span className="mr-1 minText">Min%:</span>
                                                <DecimalInput hintText="%" name={`ProductTerpene_${item.id}_Min`} className="TerpeneNumberInput" />
                                            </div>
                                            <div className="col-xs-3 col-sm-3 col-md-3 col-lg-4 col-xl-4 p-0 d-flex align-items-center">
                                                <span className="mr-1 maxText">Max%:</span>
                                                <DecimalInput hintText="%" name={`ProductTerpene_${item.id}_Max`} fullWidth={true} className="TerpeneNumberInput" />
                                            </div>
                                            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                                                <Button style={{ minWidth: `25px`, height: `25px` }} type="IconDeleteButton" onTouchTap={() => this.deleteProductTerpene(item.id)} />
                                            </div>
                                        </div>)
                                    }
                                )
                        }
                    </div>
                </div>
                <div>
                    <Button
                        name="SaveButton"
                        className="pull-right mt-2"
                        label="SAVE RANGES"
                        primary={true}
                        onTouchTap={() => this.saveTerpenes()} />
                    <Button
                        type="Button"
                        label="CANCEL"
                        primary={true}
                        className="pull-right mt-2 mr-1"
                        onTouchTap={() => this.props.onCancel()} />
                </div>
            </React.Fragment>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        addTerpeneName: state.form["ProductTerpeneAddTerpeneName"],
        branchId: state.common.branchId,
        terpenes: state.entity.terpenes,
        productTerpenes: state.entity.productTerpenes,
        terpenesSuccess: state.entity.terpenesSuccess || false,
        addTerpeneSuccess: state.entity.addTerpeneSuccess || false,
        productName: state.form[props.pageName + "Name"] || "Unable to retrieve Product Name",
        productSKU: state.form[props.pageName + "SKU"] || "",
        getTerpenesSuccess: state.entity.getTerpenesSuccess || false,
        form: state.form
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        addTerpene: (name, branchId) => dispatch(addTerpene(name, branchId)),
        assignTerpene: (productId, terpeneId) => dispatch(assignTerpene(productId, terpeneId)),
        getProductTerpenes: (productId) => dispatch(getProductTerpenes(productId)),
        getTerpenes: () => dispatch(getTerpenes()),
        resetAssignTerpeneSuccess: () => dispatch(resetAssignTerpeneSuccess()),
        deleteTerpene: (productId, terpeneId) => dispatch(deleteTerpene(productId, terpeneId)),
        resetAddTerpene: () => dispatch(resetAddTerpene()),
        resetGetTerpenes: () => dispatch(resetGetTerpenes()),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        saveTerpene: (terpeneId, productId, min, max) => dispatch(saveTerpene(terpeneId, productId, min, max))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(ProductTerpene);
